import { useCallback, useContext, useState } from 'react'

import { LoaderContext, LoaderContextProps } from '@/Shared/ui/loader/context'

export const LoaderProvider = ({
  children,
}: {
  children: React.ReactNode
}): JSX.Element => {
  const [activeLoaders, setActiveLoaders] = useState(0)

  const increaseLoaders = useCallback(() => setActiveLoaders(prev => prev + 1), [])
  const decreaseLoaders = useCallback(
    () => setActiveLoaders(prev => Math.max(0, prev - 1)),
    [],
  )

  return (
    <LoaderContext.Provider
      value={{
        isLoading: activeLoaders > 0,
        startLoading: increaseLoaders,
        stopLoading: decreaseLoaders,
      }}
    >
      {children}
    </LoaderContext.Provider>
  )
}

export const useLoader = (): LoaderContextProps => useContext(LoaderContext)
